import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IFlightPalets, IFlightPaletsPersistence } from '../interfaces';
import { FlightPaletsMapper } from '../mappers';

export type IGetFlightPaletsRepoResponse = IRepoResponse<200, IFlightPalets[]> | IRepoResponse<400 | 500, string>;

export type IGetFlightPaletsRepo = IRepo<[any], IGetFlightPaletsRepoResponse>;

export const GetFlightPaletsRepoType = Symbol.for('GetFlightPaletsRepo');

@bind(GetFlightPaletsRepoType)
export class GetFlightPaletsRepo implements IGetFlightPaletsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ flightId }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/flights/boxes', { flight_id: flightId }) });
      if (result.status === 200) {
        const data: IFlightPalets[] = result.data.data.map((item: IFlightPaletsPersistence) => FlightPaletsMapper.toDomain(item));
        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);

      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
